import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import HomeView from './HomeView';
import DashBoard from './DashBoard';
import NoticePop from './NoticePop';

@inject('commonStore', 'companyStore')
@observer
class MainContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.companyStore.setCommonStoreInfo(this.props.commonStore);
    this.props.companyStore.onClear();
    const { sessionLoginInfo } = this.props.commonStore;
    this.props.companyStore.disCompanyList(
        (sessionLoginInfo !== null 
          && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null
          && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)? "ML" : 'M', 'Y');
    // this.props.companyStore.disCompanyList('M', 'Y');
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
        {(sessionLoginInfo !== null 
          && sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
          && sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN )
        ? <DashBoard 
            cGbn={(sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) ? sessionLoginInfo.cGbn : "" }
          />
        : <HomeView />
        }

        <NoticePop />

      </Fragment>
    );
  }

}

export default withRouter(MainContainer);
